import { render, staticRenderFns } from "./Information_mobile.vue?vue&type=template&id=a4ec1b7c&scoped=true&"
import script from "./Information_mobile.vue?vue&type=script&lang=js&"
export * from "./Information_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Information_mobile.vue?vue&type=style&index=0&id=a4ec1b7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ec1b7c",
  null
  
)

export default component.exports